import getNative from './_getNative.js';

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

export default nativeCreate;



//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/node_modules/lodash-es/_nativeCreate.js
// module id = 67
// module chunks = 0